/**
 * UnavailableState — the clean "not available on this install" surface for the CLOUD-only referral
 * module. On a LOCAL install the /referral/* routes are not mounted (every call 404s); rather than a
 * generic error, the screen renders this calm, explanatory state. Glyph + text (never color-only).
 *
 * Visually a sibling of the UI kit's 5 mandatory states (reuses the same .nv-state structure) so it
 * reads as a first-class state, not an error.
 */
import { useT } from "@/app";

export function UnavailableState() {
  const { t } = useT();
  return (
    <div className="nv-state nv-state--empty" role="status">
      <div className="nv-state__glyph" aria-hidden style={{ color: "var(--nv-steel)" }}>
        ☁
      </div>
      <div className="nv-state__title">{t("referral.unavailable.title")}</div>
      <p className="nv-state__desc">{t("referral.unavailable.desc")}</p>
    </div>
  );
}
